import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Box,
  IconButton,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondary,
  DialogActions,
  Chip,
  CircularProgress,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import toastAlert from "./toastAlert";
import { FrontendBaseUrl, getUserLocation, post } from "../apis/apis";

import SignersDialogTemplate from "./SignersDialogTemplate";
import getActivityLogUserTempResp from "./MaintainActivityLogTempresponse";

const SendEsignModalTemplate = ({
  annotations,
  setSigners,
  imageUrls,
  open,
  onClose,
  documentName,
  setDocumnetName,
  signers,
  onUpdateSigners,
  onUpdateRecipients,
  emailSubject,
  setEmailSubject,
  emailMessage,
  setEmailMessage,
  file_id,
  user_id,
  uniqIdDoc,
  user,
  primaryColorComp,
}) => {
  const [signersDialogOpen, setSignersDialogOpen] = useState(false);
  const [signerToEdit, setSignerToEdit] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [showRecipients, setShowRecipients] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [newRecipient, setNewRecipient] = useState({ email: "", name: "" });
  // Add these states at the top
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [editingRecipient, setEditingRecipient] = useState(null);
  const [isRecipientFormOpen, setIsRecipientFormOpen] = useState(false);
  const [recipientError, setRecipientError] = useState({});

  const [includeMe, setIncludeMe] = useState(false);
  const currentUser = {
    id: "me-signer",
    name: user?.first_name || `Signer ${signers.length + 1}`, // Replace with actual user name if available
    email: user?.email, // Replace with actual user email if available
    color: "#ff9800", // A unique color for the current user
  };

  useEffect(() => {
    if (!setSigners) {
      console.error("setSigners is not defined!");
      return;
    }
    if (includeMe) {
      console.log("user", user);
      setSigners((prevSigners) => {
        if (!prevSigners.find((s) => s.id === currentUser.id)) {
          return [...prevSigners, currentUser];
        }
        return prevSigners;
      });
    } else {
      setSigners((prevSigners) =>
        prevSigners.filter((s) => s.id !== currentUser.id)
      );
    }
  }, [includeMe]);
  const [emailSubjectError, setEmailSubjectError] = useState("");
  const [emailMessageError, setEmailMessageError] = useState("");
  const validateSubject = () => {
    if (!emailSubject || emailSubject.trim() === "") {
      setEmailSubjectError("Subject is required");
      return false;
    }
    setEmailSubjectError("");
    return true;
  };

  const validateMessage = () => {
    if (!emailMessage || emailMessage.trim() === "") {
      setEmailMessageError("Message is required");
      return false;
    }
    setEmailMessageError("");
    return true;
  };

  const sendToEsignApi = async () => {
    if (signers.some((signer) => signer.name === "" || signer.email === "")) {
      // alert("Please fill all fields.");
      toastAlert("error", "Please fill all signer fields");
      return;
    }
    const location = await getUserLocation();
    let email_d = user?.email;
    // let user_id = user?.user_id;

    let email_name = `${user?.first_name && user?.last_name
      ? `${user?.first_name} ${user?.last_name}`
      : user?.email
      }`;
    console.log(email_name);
    const name_sender =
      user?.first_name && user.first_name.trim() !== ""
        ? user.first_name
        : user.email.split("@")[0];
    const postData = {
      url_hashed: imageUrls,
      user_id: user_id, //sender
      signers: signers, // signerd
      message: emailMessage,
      subject: emailSubject,
      template_id: file_id,
      title: `${documentName}`,
      location_country: location.country,
      ip_address: location.ip,
      location_date: location.date,
      region: location?.region,
      timezone: location?.timezone,
      email_user: user?.email, //sender
      user_name_sender: name_sender, //sender
    };
    const apiData1 = await post("template/shareTemplates", postData); // Specify the endpoint you want to call
    console.log(apiData1);
    if (apiData1.error === true || apiData1.error === "true") {
      toastAlert("error", apiData1.message);
      // setAddFolderLoader(false);
    } else {
      //console.log(apiData1.url_data);
      toastAlert("success", apiData1.message);

      const user_id = user?.user_id;
      const emailUser = user?.email;
      const signerEmails = signers.map((signer) => signer.email).join(", ");
      let response_log = await getActivityLogUserTempResp({
        user_id: user_id,
        email: user?.email,
        file_id: apiData1.TemplateResponseId,
        event: "SHARED-DOCUMENT",
        user_shared_email: signerEmails,
        description: `${emailUser} shared template ${documentName} to email:${signerEmails}`,
      });
      if (response_log === true) {
        //console.log('MAINTAIN LOG SUCCESS');
      } else {
        //console.log('MAINTAIN ERROR LOG');
      }
      // setAddFolderLoader(false);
      // uncomment this line to download the pdf
      setTimeout(() => {
        // setSendTemplate(false);
        window.location.href = `${FrontendBaseUrl}template`;
      }, 1000);
    }
  };
  const validateAccessCode = (code) => {
    const regex = /^[a-zA-Z0-9]{6}$/;
    return regex.test(code);
  };
  // Add recipient validation
  const validateRecipient = () => {
    const errors = {};
    if (!recipientName.trim()) errors.name = "Name is required";
    if (!recipientEmail.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(recipientEmail)) {
      errors.email = "Invalid email format";
    }
    setRecipientError(errors);
    return Object.keys(errors).length === 0;
  };
  // Add recipient handler
  const handleAddRecipient = () => {
    if (!validateRecipient()) return;

    if (recipients.length >= 8) {
      toastAlert("error", "Maximum 8 recipients allowed");
      return;
    }

    const newRecipient = {
      id: Date.now(),
      name: recipientName,
      email: recipientEmail,
    };

    if (editingRecipient !== null) {
      setRecipients(
        recipients.map((r, i) => (i === editingRecipient ? newRecipient : r))
      );
    } else {
      setRecipients([...recipients, newRecipient]);
    }

    setRecipientName("");
    setRecipientEmail("");
    setEditingRecipient(null);
    setIsRecipientFormOpen(false);
  };

  const renderSigners = () => (
    <List sx={{ borderRadius: 1, mb: 2 }}>
      {signers.map((signer, index) => (
        <ListItem
          key={signer.id || `signer-${index}`}
          sx={{
            border: "1px solid #ddd",
            borderRadius: "4px",
            padding: "20px",
            mb: 1,
            display: "flex",
            flexDirection: window.innerWidth < 760 ? "column" : "row",
            alignItems: "center",
            background: "white",
            "&:hover": {
              background: "rgba(0, 0, 0, 0.02)",
            },
          }}
        >
          <Box
            sx={{
              backgroundColor: signer.color,
              marginRight: "10px",
              marginBottom: window.innerWidth < 760 ? "10px" : "0",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              flexShrink: 0,
            }}
          />
          <Box sx={{ flexGrow: 1 }}>
            <TextField
              variant="outlined"
              size="small"
              label="Name"
              value={signer?.name}
              onChange={(e) => {
                const updatedSigners = [...signers];
                updatedSigners[index].name = e.target.value;
                setSigners(updatedSigners);
              }}
              fullWidth
              sx={{ mb: 1 }}
              required
              error={!signer?.name.trim()}
              helperText={!signer?.name.trim() ? "Name is required" : ""}
            />
            <TextField
              style={{ marginTop: "10px" }}
              variant="outlined"
              size="small"
              label="Email"
              value={signer?.email}
              onChange={(e) => {
                const updatedSigners = [...signers];
                updatedSigners[index].email = e.target.value;
                setSigners(updatedSigners);
              }}
              fullWidth
              required
              error={
                !signer?.email.trim() ||
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signer?.email)
              }
              disabled={signer.id === currentUser.id}
              helperText={
                !signer.email.trim()
                  ? "Email is required"
                  : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signer?.email)
                    ? "Enter a valid email"
                    : ""
              }
            />
          </Box>
        </ListItem>
      ))}
    </List>
  );

  // Add recipient form component
  const RecipientForm = () => (
    <Box sx={{ mt: 2, p: 2, bgcolor: "#f8f9fa", borderRadius: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        Add Recipient
      </Typography>
      <TextField
        fullWidth
        label="Name"
        size="small"
        value={recipientName}
        onChange={(e) => setRecipientName(e.target.value)}
        error={!!recipientError.name}
        helperText={recipientError.name}
        sx={{ mb: 2 }}
      />
      <TextField
        fullWidth
        label="Email"
        size="small"
        value={recipientEmail}
        onChange={(e) => setRecipientEmail(e.target.value)}
        error={!!recipientError.email}
        helperText={recipientError.email}
        sx={{ mb: 2 }}
      />
      <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
        <Button onClick={() => setIsRecipientFormOpen(false)}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleAddRecipient}
          sx={{
            backgroundColor: "#21b3e8",
            "&:hover": { backgroundColor: "#00bcff" },
          }}
        >
          {editingRecipient !== null ? "Update" : "Add"} Recipient
        </Button>
      </Box>
    </Box>
  );
  const validateSigners = () => {
    return signers.every(
      (signer) =>
        signer.name &&
        signer.name.trim() !== "" &&
        signer.email &&
        signer.email.trim() !== "" &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signer.email)
    );
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={(event, reason) => {
          // Prevent modal from closing if sending is in progress
          if (isSending) return;
          onClose();
        }}
        maxWidth="lg"
        fullWidth
        fullScreen={window.innerWidth < 760}
        PaperProps={{
          sx: {
            minHeight: { xs: "85vh", md: "70vh" },
            maxHeight: { xs: "90vh", md: "80vh" },
            px: { xs: 1, sm: 2 },
            py: { xs: 1, sm: 2 },
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgba(0,0,0,0.12)",
            pb: 2,
            flexShrink: 0,
            backgroundColor: "#f8f9fa",
          }}
        >
          <Typography
            variant="h6"
            fontWeight={600}
            fontSize={{ xs: 16, sm: 20 }}
          >
            Send Document for E-Signing
          </Typography>
          <IconButton
            disabled={isSending} // Disable close button when sending
            onClick={onClose}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2, flex: 1, minHeight: 0, overflow: "auto" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 4,
            }}
          >
            {/* Left Section */}
            <Box
              sx={{
                flex: 1,
                borderRight: {
                  xs: "none",
                  md: "1px solid rgba(0,0,0,0.12)",
                },
                pr: { md: 4 },
              }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 3, fontWeight: 500, fontSize: { xs: 16, sm: 18 } }}
              >
                Document Details
              </Typography>

              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    mb: 1,
                    color: "rgba(0, 0, 0, 0.6)",
                    fontSize: { xs: 12, sm: 14 },
                  }}
                >
                  Edit Document Name
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Edit Document Name"
                  error={!documentName?.trim()}
                  helperText={
                    !documentName?.trim() ? "Document name is required" : ""
                  }
                  value={documentName}
                  onChange={(e) => setDocumnetName(e.target.value)}
                  sx={{ mb: 3 }}
                />

                <Typography
                  variant="subtitle2"
                  sx={{
                    mb: 1,
                    color: "rgba(0, 0, 0, 0.6)",
                    fontSize: { xs: 12, sm: 14 },
                  }}
                >
                  Email Subject
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  error={!emailSubject?.trim() || Boolean(emailSubjectError)}
                  helperText={
                    !emailSubject?.trim() || emailSubjectError
                      ? emailSubjectError || "Subject is required"
                      : ""
                  }
                  value={emailSubject}
                  onChange={(e) => {
                    setEmailSubject(e.target.value);
                    if (e.target.value.trim()) setEmailSubjectError("");
                  }}
                  onBlur={() => {
                    if (!emailSubject?.trim()) {
                      setEmailSubjectError("Subject is required");
                    }
                  }}
                  sx={{ mb: 3 }}
                />

                <Typography
                  variant="h6"
                  sx={{ mb: 2, fontWeight: 500, fontSize: { xs: 16, sm: 18 } }}
                >
                  Signers
                </Typography>
                {renderSigners()}
                {/* <FormControlLabel
                  control={
                    <Checkbox
                      checked={includeMe}
                      onChange={() => setIncludeMe(!includeMe)}
                    />
                  }
                  label="Add me as a signer"
                /> */}
              </Box>
            </Box>

            {/* Right Section - Email Message */}
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 1,
                  color: "rgba(0, 0, 0, 0.6)",
                  fontSize: { xs: 12, sm: 14 },
                }}
              >
                Email Message
              </Typography>
              <TextField
                fullWidth
                multiline
                error={Boolean(emailMessageError)}
                helperText={emailMessageError}
                rows={12}
                value={emailMessage}
                onChange={(e) => setEmailMessage(e.target.value)}
                sx={{ mb: 2 }}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            flexShrink: 0,
            display: "flex",
            justifyContent: "flex-end",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
            px: { xs: 1, sm: 2 },
            py: 2,
            m: 0,
            borderTop: "1px solid rgba(0,0,0,0.12)",
          }}
        >
          <Button
            fullWidth={window.innerWidth < 760 ? true : false}
            disabled={isSending || !validateSigners() || signers.length === 0}
            onClick={async () => {
              const isSubjectValid = validateSubject();
              const isMessageValid = validateMessage();
              const areSignersValid = validateSigners();

              if (!isSubjectValid || !isMessageValid) return;
              if (!areSignersValid) {
                toastAlert(
                  "error",
                  "Please fill all signer fields with valid information"
                );
                return;
              }
              setIsSending(true);
              try {
                await sendToEsignApi();
              } catch (error) {
                console.error("Error sending document:", error);
                toastAlert("error", "Failed to send document");
              } finally {
                setIsSending(false);
              }
            }}
            variant="contained"
            sx={{
              backgroundColor: primaryColorComp || "#21b3e8",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: primaryColorComp || "#00bcff",
              },
              px: 4,
              height: 40,
            }}
          >
            {isSending ? (
              <>
                <CircularProgress
                  size={24}
                  sx={{
                    color: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
                <span style={{ opacity: 0 }}>Send</span>
              </>
            ) : (
              "Send"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <SignersDialogTemplate
        open={signersDialogOpen}
        onClose={() => {
          setSignersDialogOpen(false);
          setSignerToEdit(null);
        }}
        signers={signers}
        setSigners={(data) => onUpdateSigners(data)}
        signerToEdit={signerToEdit}
        file_id={file_id} // Make sure to pass file_id as prop
      />
    </>
  );
};

export default SendEsignModalTemplate;
